import { RouteObject } from "react-router-dom";

import ProtectedRoute from "../Routes/ProtectedRoute";
import { PredefinedWord } from "../Routes/Predefined";
import { ROUTES } from "../Routes/routes";

import MillingHubLayout from "../layouts/MillingHubLayouts";
import MillingHubDashboard from "../components/MillingHub/MillingHubDashboard";
import MillingProfile from "../components/MillingHub/MillingProfile";
import AddMachine from "../components/MillingHub/Addmachine";
import MillingReport from "../components/MillingHub/MillingReport";
import ChangePassword from "../layouts/ChangePassword";
import HubSchedule from "../components/MillingHub/HubSchedule";
import MillingCompleteOrder from "../components/MillingHub/MillingCompleteOrder";

export const millingRoutes: RouteObject[] = [
  {
    element: (
      <ProtectedRoute
        allowedRoles={[PredefinedWord.Roles.MILLING_HUB]}
      />
    ),
    children: [
      {
        element: <MillingHubLayout />,
        children: [
          {
            path: ROUTES.MILLING.MILLING_HUB_DASHBOARD,
            element: <MillingHubDashboard />,
          },
          {
            path: ROUTES.MILLING.MILLING_PROFILE,
            element: <MillingProfile />,
          },
          {
            path: ROUTES.MILLING.MILLING_AddMachine,
            element: <AddMachine />,
          },
          {
            path: ROUTES.MILLING.MILLING_Report,
            element: <MillingReport />,
          },
          {
            path: ROUTES.MILLING.ChangePassword,
            element: <ChangePassword />,
          },
          {
            path: ROUTES.MILLING.Settings.officetimings,
            element: <HubSchedule />,
          },
          {
            path: ROUTES.MILLING.MillingCompleteOrder,
            element: <MillingCompleteOrder />,
          },
        ],
      },
    ],
  },
];